import React, { useMemo } from 'react'
import { Dropdown } from 'react-bootstrap'

interface DropdownItem {
  label: string
  value: any
}

interface CheckboxDropdownProps {
  items: DropdownItem[]
  value: any
  onChange: (value: any) => void
}

const splitCommaList = (raw: string | undefined | null): string[] =>
  raw
    ? raw
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean)
    : []

const CheckboxDropdown: React.FC<CheckboxDropdownProps> = ({
  items,
  onChange,
  value,
}) => {
  const valueStr = typeof value === 'string' ? value : ''
  const selectedIds = useMemo(() => splitCommaList(valueStr), [valueStr])

  const toggleSelection = (id: string): void => {
    const nextIds = selectedIds.includes(id)
      ? selectedIds.filter((item) => item !== id)
      : [...selectedIds, id]
    onChange(nextIds.join(','))
  }

  const displayText = useMemo(() => {
    if (selectedIds.length === 0) {
      return ''
    }
    return selectedIds
      .map((token) => {
        const item = items.find((i) => String(i.value) === String(token))
        return item?.label ?? token
      })
      .join(', ')
  }, [selectedIds, items])

  return (
    <Dropdown>
      <Dropdown.Toggle as="div" className="form-select">
        {!displayText ? (
          'Select'
        ) : (
          <span
            style={{
              width: '95%',
              wordWrap: 'break-word',
              textWrap: 'wrap',
              margin: '4px 2px',
            }}
          >
            {displayText}
          </span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {items.map((item) => (
          <Dropdown.Item
            key={String(item.value)}
            as="div"
            onClick={(e: React.MouseEvent) => e.stopPropagation()} // Prevent dropdown from closing
          >
            <label style={{ marginBottom: 0 }} className="form-check-label">
              <input
                type="checkbox"
                className="form-check-input"
                checked={selectedIds.includes(String(item.value))}
                onChange={() => toggleSelection(String(item.value))}
                style={{ marginRight: '8px' }}
              />
              {item.label}
            </label>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default CheckboxDropdown
